export interface FreightCompanyData {
  onboardingStatus?: string;
  rulesAssessment?: string | null;
}

export const ONBOARDING_STATUS_DO_NOT_DISPATCH = 'D';
export const RULES_ASSESSMENT_FAIL = 'F';

export const getHasLimitedFreightAccess = (
  data?: FreightCompanyData
): boolean => {
  if (!data) {
    return false;
  }

  const failsRulesAssessment =
    data.rulesAssessment === RULES_ASSESSMENT_FAIL ||
    data.rulesAssessment == null;

  return (
    data.onboardingStatus === ONBOARDING_STATUS_DO_NOT_DISPATCH ||
    failsRulesAssessment
  );
};
